import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { Menu } from "@mui/material";
import { ReactComponent as DropArrow } from "../../Assets/common/droparrow.svg";

export default function DropdownList({
  data,
  title,
  style,
  onValueSelect,
  selectOption,
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => setOpen((prevOpen) => !prevOpen);

  const handleClose = () => setOpen(false);

  const handleValueSelect = (value) => {
    onValueSelect(value);
    setOpen(false); // Close after selection
  };

  const menuItems = React.useMemo(
    () =>
      data?.map((item, index) => {
        const isSelect = item === selectOption;
        return (
          <MenuItem
            key={`menu-list-${index}`}
            sx={{
              backgroundColor: isSelect ? "#e95655 !important" : "transparent",
              color: isSelect ? "#ffffff" : "#000000",
            }}
            onClick={() => handleValueSelect(item)}
          >
            {item}
          </MenuItem>
        );
      }),
    [data, selectOption]
  );

  return (
    <>
      <div
        ref={anchorRef}
        id="composition-button"
        onClick={handleToggle}
        title={title}
        className="point text-center"
        style={style ? style : { width: "120px" }}
        aria-haspopup="true"
        aria-expanded={open}
        role="button"
      >
        {title}
        {style ? null : (
          <span style={{ background: "transparent" }}>
            <DropArrow
              style={{
                width: "22px",
                height: "22px",
                // color: "#000000",
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </span>
        )}
      </div>

      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "composition-button",
        }}
        aria-hidden={!open}
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        {menuItems}
      </Menu>
    </>
  );
}
